import React from 'react';
import { Card, ListGroup, Badge } from 'react-bootstrap';
import { FaMoneyBillWave } from 'react-icons/fa';

const RecentPayments = ({ payments }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
        }).format(amount);
    };

    return (
        <Card className="shadow-sm border-0 h-100">
            <Card.Header className="bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                <h5 className="mb-0 d-flex align-items-center">
                    <FaMoneyBillWave className="me-2 text-info" /> Recent Pending Payments
                </h5>
                <Badge bg="info" pill>{payments.pendingPayments} Active</Badge>
            </Card.Header>
            <Card.Body className="p-0">
                <ListGroup variant="flush">
                    {payments.recentPending?.length > 0 ? (
                        payments.recentPending.map((p, idx) => (
                            <ListGroup.Item key={idx} className="px-3 py-2 border-0 bg-transparent">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div className="small fw-bold">{p.application?.applicationNo || 'N/A'}</div>
                                        <div className="text-muted" style={{ fontSize: '11px' }}>
                                            {p.application?.firstName} {p.application?.lastName}
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <div className="fw-bold text-dark">{formatCurrency(p.amount)}</div>
                                        <div className="text-muted" style={{ fontSize: '10px' }}>
                                            {new Date(p.createdAt).toLocaleDateString()}
                                        </div>
                                    </div>
                                </div>
                            </ListGroup.Item>
                        ))
                    ) : (
                        <div className="text-center py-4 text-muted small">No pending payments found.</div>
                    )}
                </ListGroup>
                {payments.recentPending?.length > 0 && (
                    <div className="p-3 text-center border-top">
                        <small className="text-muted">Total Pending: <strong>{formatCurrency(payments.pendingPayments * 500)}</strong> (Est.)</small>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default RecentPayments;
